import {
  Autocomplete,
  FiltrosChips,
  FiltrosDrawer,
  FiltrosSecao,
  MenuItem,
  Select,
  TextField,
} from "../../../../../components";
import {
  ANOS,
  PERIODOS,
  PERIODO_DESCRICOES,
  labelPeriodo,
} from "../dashboard-dre";

const POPPER_SX = { sx: { zIndex: 9000 } };
const SELECT_PROPS = { MenuProps: { sx: { zIndex: 9000 } } };

function chipsAtivos(filtros, acessosEmpresas, aplicar) {
  const remover = (patch) => aplicar({ ...filtros, ...patch });
  const chips = [
    {
      key: "ano",
      icon: "ph-calendar-blank",
      label: `Exercício ${filtros.ano}`,
    },
    {
      key: "periodo",
      icon: "ph-columns",
      label: labelPeriodo(filtros.periodo),
    },
  ];
  if (acessosEmpresas.length > 0) {
    filtros.empresas?.forEach((e) =>
      chips.push({
        key: `emp-${e.id}`,
        icon: "ph-buildings",
        label: e.razaoSocial,
        onDelete: () =>
          remover({ empresas: filtros.empresas.filter((x) => x.id !== e.id) }),
      }),
    );
  }
  return chips;
}

function DreFiltros({
  filtros,
  filtrosPadrao,
  onAplicar,
  acessosEmpresas,
  draft,
  setDraft,
  open,
  setOpen,
}) {
  const setCampo = (campo, valor) =>
    setDraft((prev) => ({ ...prev, [campo]: valor }));

  const aplicar = () => {
    onAplicar(draft);
    setOpen(false);
  };

  return (
    <>
      <FiltrosChips chips={chipsAtivos(filtros, acessosEmpresas, onAplicar)} />

      <FiltrosDrawer
        open={open}
        onClose={() => setOpen(false)}
        onLimpar={() => setDraft(filtrosPadrao)}
        onAplicar={aplicar}
      >
        {acessosEmpresas.length > 0 && (
          <FiltrosSecao titulo="Unidades">
            <Autocomplete
              multiple
              filterSelectedOptions
              options={acessosEmpresas}
              disableCloseOnSelect
              getOptionLabel={(opt) => opt?.razaoSocial ?? ""}
              isOptionEqualToValue={(opt, val) =>
                String(opt?.id) === String(val?.id)
              }
              value={draft.empresas ?? []}
              onChange={(_, val) => setCampo("empresas", val)}
              slotProps={{ popper: POPPER_SX }}
              renderInput={(params) => (
                <TextField {...params} label="Unidade(s)" />
              )}
            />
          </FiltrosSecao>
        )}
        <FiltrosSecao titulo="Exercício">
          <Select
            label="Ano"
            disableClearable
            value={draft.ano}
            onChange={(e) => setCampo("ano", parseInt(e.target.value, 10))}
            SelectProps={SELECT_PROPS}
          >
            {ANOS.map((ano) => (
              <MenuItem key={ano} value={ano}>
                {ano}
              </MenuItem>
            ))}
          </Select>
        </FiltrosSecao>

        <FiltrosSecao
          titulo="Agrupamento das colunas"
          descricao={PERIODO_DESCRICOES[draft.periodo]}
        >
          <Select
            label="Período"
            disableClearable
            value={draft.periodo}
            onChange={(e) => setCampo("periodo", e.target.value)}
            SelectProps={SELECT_PROPS}
          >
            {PERIODOS.map((periodo) => (
              <MenuItem key={periodo.value} value={periodo.value}>
                {periodo.label}
              </MenuItem>
            ))}
          </Select>
        </FiltrosSecao>
      </FiltrosDrawer>
    </>
  );
}

export default DreFiltros;
